var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284.514,
    height: 266.607,
    viewBox: "0 0 284.514 266.607",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1231",
    "data-name": "Group 1231",
    transform: "translate(-21546.742 19429.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1616",
    "data-name": "Path 1616",
    d: "M171.6,65.905C157.12,34.984,130.321,19.483,112,10.452,82.74-3.972,24.569-8.646,5.8,31.026c-21.126,44.663,21.44,68.3,31.709,80.379,15.232,17.919,19.787,39,11.158,70.017s23.618,45.565,43.782,43.8c28.567-2.5,62.662-15.108,80.385-55.583S186.081,96.826,171.6,65.905Z",
    transform: "matrix(0.454, -0.891, 0.891, 0.454, 21546.742, -19264.877)",
    fill: "#f2f8f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "noun_thumbs_up_981429",
    "data-name": "noun_thumbs up_981429",
    transform: "translate(21609.164 -19393.197)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1552",
    "data-name": "Path 1552",
    d: "M106.075,60.316a7.569,7.569,0,0,0-7.861-7.861H76.351a3.051,3.051,0,0,1-1.965-1.474c-.983-1.965-.983-5.65.491-10.072,2.948-9.089,1.228-18.424-4.667-24.565-2.457-2.7-8.6-5.4-12.774-4.422a6.42,6.42,0,0,0-4.667,4.667q-1.105,4.422,2.211,11.054a31.753,31.753,0,0,1,2.948,10.317,4.15,4.15,0,0,1-.737,2.457,2.667,2.667,0,0,1-2.211.983c-5.4.246-9.335,2.457-11.3,6.878a9.9,9.9,0,0,1-8.107,4.176H32.133a7.344,7.344,0,0,0-6.141-3.194H18.13v3.685h7.861a3.88,3.88,0,0,1,3.93,3.93V91.023a3.88,3.88,0,0,1-3.93,3.93H14.2v3.685H25.991a7.475,7.475,0,0,0,5.9-2.7v.491c1.228,0,4.667.246,6.633,1.474a10.682,10.682,0,0,0,1.72.983,35.488,35.488,0,0,0,11.546,4.667c2.457.491,8.107.737,14.248.737,9.826,0,21.126-.491,21.618-.491h0a7.569,7.569,0,0,0,7.861-7.861,7.423,7.423,0,0,0-1.228-3.93h.246a7.76,7.76,0,0,0,7.861-7.861,7.928,7.928,0,0,0-1.965-5.159,7.978,7.978,0,0,0,1.965-12.528h0A6.505,6.505,0,0,0,106.075,60.316ZM97.231,76.529H84.7v3.685H95.02a4.093,4.093,0,0,1,3.93,4.176,4.3,4.3,0,0,1-4.176,4.176H81.018v3.685h7.124a3.88,3.88,0,0,1,3.93,3.93,4.532,4.532,0,0,1-1.228,2.948,4.068,4.068,0,0,1-2.948,1.228c-8.107.246-30.215.983-35.129-.246A27.026,27.026,0,0,1,42.2,95.691c-.491-.246-1.228-.737-1.72-.983a21.089,21.089,0,0,0-6.878-1.965,4.18,4.18,0,0,0,.246-1.72V56.14h2.211a13.75,13.75,0,0,0,11.3-5.9L47.609,50c1.228-2.948,4.176-4.667,8.107-4.667a7.065,7.065,0,0,0,4.913-2.211,6.635,6.635,0,0,0,1.72-5.159A30.041,30.041,0,0,0,58.909,26.17c-1.965-3.439-2.457-6.141-1.965-8.352a2.342,2.342,0,0,1,1.965-1.965c2.7-.737,7.37,1.474,9.089,3.439,4.913,5.159,6.387,12.774,3.685,20.881-.983,3.194-2.457,9.089-.246,13.02a6.606,6.606,0,0,0,4.422,3.194H98.214a4.532,4.532,0,0,1,2.948,1.228,4.068,4.068,0,0,1,1.228,2.948,4.3,4.3,0,0,1-4.176,4.176h-14v3.685h13.02a4.532,4.532,0,0,1,2.948,1.228,4.068,4.068,0,0,1,1.228,2.948A4.27,4.27,0,0,1,97.231,76.529Z",
    transform: "translate(20.683 17.065)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1184",
    "data-name": "Rectangle 1184",
    width: 3.685,
    height: 15.722,
    transform: "translate(77.872)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1185",
    "data-name": "Rectangle 1185",
    width: 15.722,
    height: 3.685,
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 41.688, 9.788)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1186",
    "data-name": "Rectangle 1186",
    width: 15.722,
    height: 3.685,
    transform: "matrix(-0.866, -0.5, 0.5, -0.866, 23.379, 49.339)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1187",
    "data-name": "Rectangle 1187",
    width: 15.722,
    height: 3.685,
    transform: "translate(0 77.872)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1188",
    "data-name": "Rectangle 1188",
    width: 3.685,
    height: 15.722,
    transform: "matrix(-0.5, -0.866, 0.866, -0.5, 11.733, 121.449)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1189",
    "data-name": "Rectangle 1189",
    width: 3.685,
    height: 15.722,
    transform: "matrix(-0.866, -0.5, 0.5, -0.866, 41.471, 149.916)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1190",
    "data-name": "Rectangle 1190",
    width: 3.685,
    height: 15.722,
    transform: "translate(77.872 143.954)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1191",
    "data-name": "Rectangle 1191",
    width: 15.722,
    height: 3.685,
    transform: "matrix(-0.5, -0.866, 0.866, -0.5, 118.041, 149.912)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1192",
    "data-name": "Rectangle 1192",
    width: 15.722,
    height: 3.685,
    transform: "matrix(-0.866, -0.5, 0.5, -0.866, 148.074, 121.392)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1193",
    "data-name": "Rectangle 1193",
    width: 15.722,
    height: 3.685,
    transform: "translate(143.953 77.872)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1194",
    "data-name": "Rectangle 1194",
    width: 3.685,
    height: 15.722,
    transform: "matrix(0.5, 0.866, -0.866, 0.5, 147.925, 38.285)",
    fill: "#5f908f"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1195",
    "data-name": "Rectangle 1195",
    width: 3.685,
    height: 15.722,
    transform: "matrix(0.866, 0.5, -0.5, 0.866, 118.175, 9.697)",
    fill: "#5f908f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.a12feca0d0e2cb3bf41b8034e203bfbc.svg";
export { ForwardRef as ReactComponent };